/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
   let inventoryHash = document.querySelectorAll('[inventorymanagment]'); 
      
  Array.from(inventoryHash).forEach( 
    
         (Selectedvariant)=>{ 
           if(Selectedvariant.dataset.id == variant.id){ 
             if(Selectedvariant.dataset.inventory > 0) 
             { 
               $("#variant-inventory").html("We have"+ Selectedvariant.dataset.inventory +" in stock");
   
             } 
             else{ 
               $("#variant-inventory").html("Sold out!"); 
             } 
           } 
           
           
           
           if(Selectedvariant.dataset.id == variant.id){ 
             if(Selectedvariant.dataset.inventory > 0 && Selectedvariant.dataset.size == variant.option1 && Selectedvariant.dataset.color == variant.option2 ) 
             { 
                $(".HorizontalList__Item."+Selectedvariant.dataset.size).removeClass("bgblurs");
   
             } 
             else{ 
                $(".HorizontalList__Item."+Selectedvariant.dataset.size).removeClass("bgblurs");
               $( ".HorizontalList__Item."+Selectedvariant.dataset.size ).addClass( 'bgblurs');
   
             } 
   
           } 
           
           
          
           
   
         } 
       ); 
  });

$(document).on('click', '.ProductForm .ProductForm__AddToCart_Modal', function (e) {
    e.preventDefault();
    e.stopPropagation();
   
     var i = document.querySelector(".ProductForm__AddToCart_Modal");
         i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
         var n = document.querySelector('form[action*="/cart/add"]');
         var paramObj = {};
         $.each($('form[action*="/cart/add"]').serializeArray(), function (_, kv) {
             if (paramObj.hasOwnProperty(kv.name)) {
                 paramObj[kv.name] = $.makeArray(paramObj[kv.name]);
                 paramObj[kv.name].push(kv.value);
             }
             else {
                 paramObj[kv.name] = kv.value;
             }
         });
         fetch(window.routes.cartAddUrl + ".js", {
             body: JSON.stringify(paramObj),
             credentials: "same-origin",
             method: "POST",
             headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
         }).then(function (e) {
             document.dispatchEvent(new CustomEvent("theme:loading:end"));
                 if( e.ok )
                 {
                     i.removeAttribute("disabled");
                     
                       document.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { variant: document.currentVariant, quantity: parseInt(n.querySelector('[name="quantity"]').value) } }));
                       
                 }
                 else {
                     e.json().then(function (e) {
                         var t = document.createElement("span");
                         (t.className = "ProductForm__Error Alert Alert--error"),
                             (t.innerHTML = e.description),
                             i.removeAttribute("disabled"),
                             i.insertAdjacentElement("afterend", t),
                             setTimeout(function () {
                                 t.remove();
                             }, 2500);
                     });
                 }
            return e.json();
         }).then(function(response) {
             
           if (response)
           { 
             $('#bundle-product-modal-qty').val(response.quantity);
             $('#bundle-product-modal-key').val(response.key);
             $('#bundle-product-modal-image').attr('src', response.image);
             
             
             $('#bundle-product-modal-title').text(response.title);
             $('#bundle-product-modal-type').text(response.product_type);
             $('#bundle-product-modal-price').text('$' + (response.price/100));
             
             if ( response.options_with_values )
             {
               const ulElement = document.createElement('ul');
               $.each( response.options_with_values, function( index, variant ){
                     
                     const selectedVariant = $('.li_product_list[data-id="' + response.product_id + '"]');
                 
                     selectedVariant.find('select.th_pb_option_select_cls[data-name="'+ variant.name +'"]')
                     .val(variant.value);
                 
                     const selectedVariantId = selectedVariant.find('select.th_pb_pro_variants option[data-title="'+ variant.value +'"]').val();
                     
                     console.log(selectedVariantId);
                     
                     selectedVariant.find('select.th_pb_pro_variants').val(selectedVariantId);
                     
                     const liElement = document.createElement('li');
                     
                     const spanElement = document.createElement('span');
                     spanElement.classList.add('lead');
                     const variantSelected = variant.name + ' : ' + variant.value;
                     spanElement.innerText = variantSelected;
                       
                     liElement.append(spanElement);
                 
                     ulElement.appendChild(liElement);
               });
               
               $('#bundle-product-modal-variant').html(ulElement);
             }
             
             $('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]').click();
             
             $('html').addClass('no-scroll');
             
             $('.th_pb_section .li_product_list[data-id="' + response.product_id + '"]').css('display', 'none');
             
             $('#th_pb_product_bundle_quickview_id').addClass('th_pb_quickview_popupzoom_in');
           }
         });
  });
 
 $(document).on('click', '#th_pb_close_bundle_quickview_popup', function (e) {
   e.preventDefault();
   $('html').removeClass('no-scroll');
   $('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')[0].click();
   $(this).closest('#th_pb_product_bundle_quickview_id').removeClass('th_pb_quickview_popupzoom_in');
 });
 
 function updateCartItem(formId, alertPopUp = true)
 {
   document.dispatchEvent(new CustomEvent("theme:loading:start"));
   
   var paramObj = {};
   $.each($('#'+formId).serializeArray(), function (_, kv) {
     if (paramObj.hasOwnProperty(kv.name)) {
       paramObj[kv.name] = $.makeArray(paramObj[kv.name]);
       paramObj[kv.name].push(kv.value);
     }
     else {
       paramObj[kv.name] = kv.value;
     }
   });
 
   fetch(window.routes.cartChangeUrl + ".js", {
             body: JSON.stringify(paramObj),
             credentials: "same-origin",
             method: "POST",
             headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
         }).then(function (e) {
             document.dispatchEvent(new CustomEvent("theme:loading:end"));
              if( e.ok )
             {
               document.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { variant: document.currentVariant, quantity: parseInt(document.querySelector('[name="quantity"]').value) } }));
               
               if( paramObj['quantity'] == 0){
                 if ( alertPopUp )
                 {
                 alert('Product has been removed from the cart');
                 location.reload();
                 }
               }else {
                 alert('Product Quantity Updated Successfully!');
               }
             }
           else {
             
           }
       });
 }
 
 
 // Quick Add to cart Functionality
 function addItemToCart(form_id) 
 {
           var n = $('#add-item-form-' + form_id);
           
           document.dispatchEvent(new CustomEvent("theme:loading:start"));
   
         var paramObj = {};
         $.each($('#add-item-form-' + form_id).serializeArray(), function (_, kv) {
             if (paramObj.hasOwnProperty(kv.name)) {
                 paramObj[kv.name] = $.makeArray(paramObj[kv.name]);
                 paramObj[kv.name].push(kv.value);
             }
             else {
                 paramObj[kv.name] = kv.value;
             }
         });
         fetch(window.routes.cartAddUrl + ".js", {
             body: JSON.stringify(paramObj),
             credentials: "same-origin",
             method: "POST",
             headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
         }).then(function (e) {
                 document.dispatchEvent(new CustomEvent("theme:loading:end"));
                   document.dispatchEvent(new CustomEvent("product:added", { bubbles: !0, detail: { variant: document.currentVariant, quantity: parseInt(n.find('[name="quantity"]').val()) } }));
                   if( e.ok ) { 
 //                   	alert('Product added to the cart successfully');
                   n.closest('#th_pb_product_bundle_quickview_id').removeClass('th_pb_quickview_popupzoom_in');
                 }
                 else {
                     e.json().then(function (e) {});
                 }
         });
 }
 
 function updateQty(inputId, action) {
     let itemQty = parseInt($('#'+inputId).val());
       
       if( action === 'increase' )
     {
       itemQty++;
     }
       else {
         itemQty--;
     }
   
   $('#'+inputId).val(itemQty);
 }



$(document).ready(function(){
 var colorswatch = $('.ColorSwatch__Radio').val();
 $(".colorswatch").text(colorswatch+" ");
})

// var acc = document.getElementsByClassName("accordion");
// var i;

// for (i = 0; i < acc.length; i++) {
//   acc[i].addEventListener("click", function() {
//     this.classList.toggle("active");

//       var parent = this.parentElement;

   
//       var panel = parent.nextElementSibling;
//     var panel = this.nextElementSibling;
//     if (panel.style.display === "block") {
//       panel.style.display = "none";
//     } else {
//       panel.style.display = "block";
//     }
//   });
// }
document.addEventListener("DOMContentLoaded", function () {
  var acc = document.getElementsByClassName("accordion");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      console.log("lll");
      this.classList.toggle("active");

      // Get the parent element of the button
      var parent = this.parentElement;

      // Find the next sibling of the parent (which should be the panel)
      var panel = this.nextElementSibling;

      if (panel && panel.classList.contains("panel")) {
        // Toggle visibility
        if (window.getComputedStyle(panel).display === "block") {
          console.log("III");
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      }
    });
  }
});



function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}



$(".ColorSwatch").on("click",function(){
 $(".ColorSwatch").removeClass("intro");
     $(this).addClass("intro");
});



$("button.ColorSwatch.Lick").on("mouseenter", function() {
      $("button span.Lick").show();
}).on("mouseleave", function() {
      $("button span.Lick").hide();
});
$("button.ColorSwatch.Sesame").on("mouseenter", function() {
      $("button span.Sesame").show();
}).on("mouseleave", function() {
      $("button span.Sesame").hide();
});
$("button.ColorSwatch.Twilight").on("mouseenter", function() {
      $("button span.Twilight").show();
}).on("mouseleave", function() {
      $("button span.Twilight").hide();
});
$("button.ColorSwatch.Hot.Sauce").on("mouseenter", function() {
      $("button span.Hot.Sauce").show();
}).on("mouseleave", function() {
      $("button span.Hot.Sauce").hide();
});
$("button.ColorSwatch.Truffle").on("mouseenter", function() {
      $("button span.Truffle").show();
}).on("mouseleave", function() {
      $("button span.Truffle").hide();
});
$("button.ColorSwatch.Butter").on("mouseenter", function() {
      $("button span.Butter").show();
}).on("mouseleave", function() {
      $("button span.Butter").hide();
});
$("button.ColorSwatch.Beam").on("mouseenter", function() {
      $("button span.Beam").show();
}).on("mouseleave", function() {
      $("button span.Beam").hide();
});
$("button.ColorSwatch.Tumble").on("mouseenter", function() {
      $("button span.Tumble").show();
}).on("mouseleave", function() {
      $("button span.Tumble").hide();
});
$("button.ColorSwatch.Charm").on("mouseenter", function() {
      $("button span.Charm").show();
}).on("mouseleave", function() {
      $("button span.Charm").hide();
});
$("button.ColorSwatch.Pixie").on("mouseenter", function() {
      $("button span.Pixie").show();
}).on("mouseleave", function() {
      $("button span.Pixie").hide();
});
$("button.ColorSwatch.Potion").on("mouseenter", function() {
      $("button span.Potion").show();
}).on("mouseleave", function() {
      $("button span.Potion").hide();
});
$("button.ColorSwatch.Fairy").on("mouseenter", function() {
      $("button span.Fairy").show();
}).on("mouseleave", function() {
      $("button span.Fairy").hide();
});
$("button.ColorSwatch.Moon").on("mouseenter", function() {
      $("button span.Moon").show();
}).on("mouseleave", function() {
      $("button span.Moon").hide();
});
$("button.ColorSwatch.Twinkle").on("mouseenter", function() {
      $("button span.Twinkle").show();
}).on("mouseleave", function() {
      $("button span.Twinkle").hide();
});




$(".metaacolor .ColorSwatch.Lick").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Lick').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Lick').hide();
});

$(".metaacolor .ColorSwatch.Sesame").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Sesame').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Sesame').hide();
});

$(".metaacolor .ColorSwatch.Twilight").on("mouseenter", function() {
     $(this).closest('.metaacolor').find('span.Twilight').show();
}).on("mouseleave", function() {
     $(this).closest('.metaacolor').find('span.Twilight').hide();
});

$(".metaacolor .ColorSwatch.Hot.Sauce").on("mouseenter", function() {
     $(this).closest('.metaacolor').find('span.Hot.Sauce').show();
}).on("mouseleave", function() {
     $(this).closest('.metaacolor').find('span.Hot.Sauce').hide();
});

$(".metaacolor .ColorSwatch.Truffle").on("mouseenter", function() {
     $(this).closest('.metaacolor').find('span.Truffle').show();
}).on("mouseleave", function() {
     $(this).closest('.metaacolor').find('span.Truffle').hide();
});

$(".metaacolor .ColorSwatch.Butter").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Butter').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Butter').hide();
});
$(".metaacolor .ColorSwatch.Beam").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Beam').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Beam').hide();
});
$(".metaacolor .ColorSwatch.Tumble").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Tumble').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Tumble').hide();
});
$(".metaacolor .ColorSwatch.Charm").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Charm').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Charm').hide();
});
$(".metaacolor .ColorSwatch.Potion").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Potion').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Potion').hide();
});
$(".metaacolor .ColorSwatch.Pixie").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Pixie').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Pixie').hide();
});
$(".metaacolor .ColorSwatch.Fairy").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Fairy').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Fairy').hide();
});
$(".metaacolor .ColorSwatch.Moon").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Moon').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Moon').hide();
});
$(".metaacolor .ColorSwatch.Twinkle").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Twinkle').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Twinkle').hide();
  });
$(".metaacolor .ColorSwatch.Court").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Court').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Court').hide();
  });
$(".metaacolor .ColorSwatch.Smoke").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Smoke').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Smoke').hide();
  });
$(".metaacolor .ColorSwatch.Polo").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Polo').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Polo').hide();
  });
$(".metaacolor .ColorSwatch.Steamy").on("mouseenter", function() {
      $(this).closest('.metaacolor').find('span.Steam').show();
}).on("mouseleave", function() {
      $(this).closest('.metaacolor').find('span.Steamy').hide();
});


$(".color .ColorSwatch.Twilight").on("mouseenter", function() {
  $(".foundation .Twilight").show();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

$(".color .ColorSwatch.Sesame").on("mouseenter", function() {
  $(".foundation .Sesame").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

  $(".color .ColorSwatch.Hot.Sauce").on("mouseenter", function() {
  $(".foundation .Hot.Sauce").show();
  $(".foundation .Sesame").hide();
  $(".foundation .Twilight").hide();
  $(".foundation .Truffle").hide();  
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

  $(".color .ColorSwatch.Truffle").on("mouseenter", function() {
  $(".foundation .Truffle").show();
  $(".foundation .Sesame").hide();
  $(".foundation .Twilight").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});


$(".color .ColorSwatch.Beam").on("mouseenter", function() {
  $(".limited-edition .Beam").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

$(".color .ColorSwatch.Butter").on("mouseenter", function() {
  $(".limited-edition .Butter").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

$(".color .ColorSwatch.Tumble").on("mouseenter", function() {
  $(".limited-edition .Tumble").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});

$(".color .ColorSwatch.Charm").on("mouseenter", function() {
  $(".limited-edition .Charm").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});
$(".color .ColorSwatch.Potion").on("mouseenter", function() {
  $(".limited-edition .Potion").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});
$(".color .ColorSwatch.Pixie").on("mouseenter", function() {
  $(".limited-edition .Pixie").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
});
$(".color .ColorSwatch.Fairy").on("mouseenter", function() {
  $(".limited-edition .Fairy").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Moon").on("mouseenter", function() {
  $(".limited-edition .Moon").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Twinkle").on("mouseenter", function() {
  $(".limited-edition .Twinkle").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Court").on("mouseenter", function() {
  $(".limited-edition .Court").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Smoke").on("mouseenter", function() {
  $(".limited-edition .Smoke").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Polo").on("mouseenter", function() {
  $(".limited-edition .Polo").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Twinkle").hide();
  $(".limited-edition .Steamy").hide();
  });
$(".color .ColorSwatch.Steamy").on("mouseenter", function() {
  $(".limited-edition .Steamy").show();
  $(".foundation .Twilight").hide();
  $(".foundation .Sesame").hide();
  $(".foundation .Hot.Sauce").hide();
  $(".foundation .Truffle").hide();
  $(".limited-edition .Lick").hide();
  $(".limited-edition .Beam").hide();
  $(".limited-edition .Butter").hide();
  $(".limited-edition .Tumble").hide();
  $(".limited-edition .Pixie").hide();
  $(".limited-edition .Charm").hide();
  $(".limited-edition .Potion").hide();
  $(".limited-edition .Moon").hide();
  $(".limited-edition .Fairy").hide();
  $(".limited-edition .Court").hide();
  $(".limited-edition .Smoke").hide();
  $(".limited-edition .Polo").hide();
  $(".limited-edition .Twinkle").hide();
});


// Get the element with id="defaultOpen" and click on it
if (document.body.id) {
    const button = document.getElementById("defaultOpen");
    if (button) {
        button.click();
    } else {
        console.warn("Element with ID 'defaultOpen' not found!");
    }
} else {
    console.warn("Body has no ID!");
}






/* accordian
================================================== */
$(function() {
  // 1. Close all panels on page load
  $('.jsc-details-cont').hide();

  // 2. Click behavior
  $('.jsc-details-title').click(function(e) {
    e.preventDefault();

    var $this = $(this);
    var $block = $this.closest('.jsc-details-block');
    var $wrap = $this.closest('.jsc-details-wrap');
    var $dropDown = $block.find('.jsc-details-cont');
    var isActive = $this.hasClass('active');

    // Close all panels and remove active state
    $wrap.find('.jsc-details-cont').slideUp();
    $wrap.find('.jsc-details-title').removeClass('active');

    // Toggle current only if not already open
    if (!isActive) {
      $this.addClass('active');
      $dropDown.stop(true, true).slideDown();
    }
  });
});

// ----------------------------------

/*jsp-banner-video-play js
================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".media-fallback");

  wrappers.forEach(function (wrapper) {
    const video = wrapper.querySelector("video");
    const button = wrapper.querySelector(".play_pause_icon");

    if (!video || !button) return;

    button.addEventListener("click", function () {
      if (video.paused) {
        video.play()
          .then(() => wrapper.classList.remove("playing"))
          .catch(err => console.log("Video play failed:", err));
      } else {
        video.pause();
        wrapper.classList.add("playing");
      }
    });

    video.addEventListener("ended", function () {
      wrapper.classList.remove("playing");
    });
  });
});


document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.custom-dropdown-toggle');
  if (toggle) {
    toggle.closest('.CustomDropdown')?.classList.toggle('active');
    return;
  }

  const item = e.target.closest('.CustomDropdown__Item');
  if (!item) return;

  const size = item.dataset.value;
  const position = item.dataset.optionPosition;
  const productForm = item.closest('.ProductForm');
  if (!productForm) return;

 let color = document.querySelector('.ColorSwatchList .limited-edition .jsc-col-current')?.innerText.trim();


    // document.querySelector('.ColorSwatch__Radio:checked')?.value ||
    // document.querySelector('.limited-edition .jsc-col[style*="inline"]')?.innerText.trim();

  const productEl = document.querySelector('[data-product-json-custom]');
  if (!productEl) return;

  let productData;
  try {
    productData = JSON.parse(productEl.textContent);
  } catch {
    return;
  }

  const variants = productData?.product?.variants;
  if (!variants) return;

  const selectedVariant = variants.find(
    (v) => v.option1 === size && v.option2 === color
  );

  console.log(selectedVariant);

  if (selectedVariant) {
    const variantId = selectedVariant.id;

    const selectEl = document.querySelector(
      '.ProductForm__Variants select[name="id"]'
    );

    if (selectEl) {
      selectEl.value = variantId;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  const selector = `.Product__OffScreen .Popover__Value[data-option-position="${position}"]`;
  const originalBtn = document.querySelector(
    `${selector}[data-value="${size}"]`
  );

  if (originalBtn) {
    document.querySelectorAll(selector).forEach((btn) =>
      btn.classList.remove('is-selected')
    );

    originalBtn.classList.add('is-selected');
    ['click', 'change'].forEach((event) =>
      originalBtn.dispatchEvent(new Event(event, { bubbles: true }))
    );
  }

  const dropdown = item.closest('.CustomDropdown');
  if (dropdown) {

    dropdown.querySelectorAll('.CustomDropdown__Item').forEach(el => {
      el.classList.remove('is-selected');
    });

    item.classList.add('is-selected');

    dropdown.querySelector('.ProductForm__SelectedValue').innerText = size;
    dropdown.classList.remove('active');
  }
});